var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterrest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2721 1.01947C11.9289 1.745 5.60801 7.00322 5.34712 14.5144C5.18314 19.1006 6.45402 22.5411 10.7139 23.5072C12.5624 20.1659 10.1176 19.429 9.73744 17.0118C8.17586 7.10632 20.8884 0.351212 27.541 7.2667C32.1437 12.0552 29.1137 26.7874 21.6897 25.2561C14.5787 23.7936 25.1706 12.0667 19.4945 9.76407C14.8806 7.89296 12.4283 15.4882 14.616 19.2609C13.3339 25.7488 10.5723 31.8623 11.6903 39.9998C15.3166 37.3038 16.5391 32.1411 17.5416 26.7569C19.3641 27.891 20.3368 29.0709 22.6624 29.2542C31.2381 29.9339 36.0272 20.4829 34.8569 11.765C33.8171 4.03617 26.2887 0.103003 18.2721 1.01947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterrest);
export default __webpack_public_path__ + "static/media/pinterrest.893c09f04bd64a41f8495930800d1b97.svg";
export { ForwardRef as ReactComponent };